import { useNavigate } from "react-router";

import { homePageVehicleTypeAtom } from "@/src/state/homePageVehicleTypeAtom";

import {
  VEHICLE_TYPE_AUCTION_BASE_PATHS,
  VEHICLE_TYPE_HOME_PATHS,
  VehicleSelectorNavigationView
} from "@/src/components/atoms/VehicleSelectorGroup/vehicleSelector.constants";

import { useAuth } from "@/src/auth/hooks/useAuth";
import { VehicleType } from "@/src/types/types";

import { useSetAtom } from "jotai";

const useVehicleSelectorNavigation = (
  navigationView: VehicleSelectorNavigationView
) => {
  const setVehicleType = useSetAtom(homePageVehicleTypeAtom);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const getAuctionPath = (value: VehicleType) => {
    const basePath = VEHICLE_TYPE_AUCTION_BASE_PATHS[value];
    return `${basePath}/${isAuthenticated ? "edit" : "create"}`;
  };

  const handleVehicleSelection = (value: VehicleType) => {
    setVehicleType(value);
    if (navigationView === "auctionWizardView") {
      navigate(getAuctionPath(value));
      return;
    }
    navigate(VEHICLE_TYPE_HOME_PATHS[value]);
  };

  return handleVehicleSelection;
};

export default useVehicleSelectorNavigation;
